<template>
  <div class="tutorial-system">
    <!-- Overlay del tutorial -->
    <TutorialOverlay
      :is-active="isTutorialActive"
      :model-name="modelName"
      :tutorial-type="tutorialType"
      @close-tutorial="deactivateTutorial"
      @tutorial-completed="handleTutorialCompleted"
    />
  </div>
</template>

<script>
import TutorialOverlay from "./TutorialOverlay.vue";

export default {
  name: "TutorialSystem",

  components: {
    TutorialOverlay,
  },

  props: {
    modelName: {
      type: String,
      default: "",
    },
    buttonPosition: {
      type: String,
      default: "bottom-right",
      validator: (value) =>
        ["bottom-right", "bottom-left", "top-right", "top-left"].includes(
          value
        ),
    },
    showButtonText: {
      type: Boolean,
      default: true,
    },
    autoShowTooltip: {
      type: Boolean,
      default: true,
    },
    autoStart: {
      type: Boolean,
      default: false,
    },
    tutorialType: {
      type: String,
      default: "listings",
      validator: (value) => ["listings", "calendar"].includes(value),
    },
    hideInternalButton: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isTutorialActive: false,
    };
  },

  mounted() {
    // Iniciar tutorial automáticamente si está configurado
    if (this.autoStart) {
      this.activateTutorial();
    }
  },

  methods: {
    activateTutorial() {
      this.isTutorialActive = true;
      this.$emit("tutorial-activated");
    },

    deactivateTutorial() {
      this.isTutorialActive = false;
      this.$emit("tutorial-deactivated");
    },

    handleTutorialCompleted() {
      this.isTutorialActive = false;
      this.$emit("tutorial-completed");
    },

    handleTooltipDismissed() {
      this.$emit("tooltip-dismissed");
    },

    // Métodos públicos para control externo
    startTutorial() {
      this.activateTutorial();
    },

    stopTutorial() {
      this.deactivateTutorial();
    },

    resetTutorial() {
      // Resetear el estado del tutorial
      localStorage.removeItem("gotrading-tutorial-completed");
      localStorage.removeItem("gotrading-tutorial-dismissed");
      this.$emit("tutorial-reset");
    },
  },
};
</script>

<style scoped>
.tutorial-system {
  /* Este componente no necesita estilos específicos */
}

/* Estilos para la notificación de éxito */
@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideOutRight {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
}

.notification-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.notification-content i {
  font-size: 20px;
}
</style>
